<template>
  <chat-message :prev-chat="prevChat" :chat="chat" hide-message @delete="$emit('delete', chat)">
    <div class="chat-message__image-am">
      <div v-if="hasTitle" class="image-title" :style="styles">
        {{ formatTitle }}
      </div>
      <a v-if="hasLink" target="_blank" :href="link">
        <img v-if="hasImage" :src="image" />
      </a>
      <img v-if="!hasLink && hasImage" :src="image" />
      <div v-if="hasFooter" class="image-footer" :style="styles">
        {{ formatFooter }}
      </div>
    </div>
  </chat-message>
</template>

<script>
import { formatChatMessage, checkImage } from 'Utilities'
import style from './scss/_advertisment.scss'
import ChatMessage from 'Chats/ChatMessage'
import chatWidgetMixin from 'Chats/mixins/chatWidgetMixin'

export default {
  components: { ChatMessage },
  mixins: [chatWidgetMixin],
  data() {
    return {
      style,
      hasImage: this.checkImage()
    }
  },
  computed: {
    formatTitle() {
      if (this.hasTitle) {
        return formatChatMessage(this.chat.message_rich.message)
      }
    },
    formatFooter() {
      if (this.hasFooter) {
        return formatChatMessage(this.chat.message_rich.message_footer)
      }
    },
    styles() {
      const fg = this.chat.message_rich.text_color
      const bg = this.chat.message_rich.background_color

      return `background-color: ${bg} !important; color: ${fg} !important;`
    },
    image() {
      return this.chat.message_rich.image
    },
    link() {
      return this.chat.message_rich.landing_url
    },
    hasFooter() {
      return (
        this.chat.message_rich.message_footer && this.chat.message_rich.message_footer.length > 0
      )
    },
    hasTitle() {
      return this.chat.message_rich.message && this.chat.message_rich.message.length > 0
    },
    hasLink() {
      return this.chat.message_rich.landing_url && this.chat.message_rich.landing_url.length > 0
    }
  },
  methods: {
    checkImage() {
      if (this.chat.message_rich.image) {
        checkImage(this.chat.message_rich.image, false, 'no image found')
          .then((success) => {
            this.hasImage = true
          })
          .catch((fail) => {
            this.hasImage = false
          })
      }
    }
  }
}
</script>
